<template>
  <v-container fluid>
    <v-card>
<v-card-title
  class="d-flex flex-column flex-sm-row align-start align-sm-center"
>
  <!-- Icon -->
  <div class="d-flex align-center justify-center  mb-2 mb-sm-0">
Fleet Dashboard
  <!-- Refresh button
    <v-btn color="primary" @click="loadData">
      <v-icon size="x-large">mdi-refresh</v-icon>
    </v-btn>

  -->
    <v-icon size="x-large">mdi-view-dashboard</v-icon>

            <v-spacer class="d-none d-sm-flex"></v-spacer>

  </div>

  <!-- Title -->

</v-card-title>

<v-card-subtitle>

                <!-- Week controls -->
              <div class="d-flex align-center justify-left mb-2 mb-sm-0">

                  {{ startOfPreviousWeek }} to {{ endOfPreviousWeek }}

                  <v-btn icon large color="primary" @click="incrementWeek">
                    <v-icon large >mdi-chevron-left-circle-outline </v-icon>
                  </v-btn>

                  <div class="mx-6">
                    <span class="font-weight-light">({{ week }})</span>
                  </div>

                  <v-btn icon large color="primary" @click="decrementWeek">
                    <v-icon large>mdi-chevron-right-circle-outline </v-icon>
                  </v-btn>
                </div>

            <v-spacer class="d-none d-sm-flex"></v-spacer>

            <!-- Spacer only for desktop -->
            <v-spacer class="d-none d-sm-flex"></v-spacer>

</v-card-subtitle>

    <!-- ================= KPI CARDS ================= -->
    <v-row dense>
      <v-col cols="12" sm="6" md="3">

        <v-card class="pa-3">
          <div class="text-caption">Total Trips</div>
          <div class="text-h5">{{ totalTrips }}</div>
          <div >
            {{ totalDTrips }} vs Last week
          </div>
        </v-card>

        <v-card class="pa-3">
          <div class="text-caption">Total Duration</div>
          <div class="text-h6">{{ totalDuration }}</div>
        </v-card>

        <v-card class="pa-3">
          <div class="text-caption">Total Distance</div>
          <div class="text-h6">{{ totalDistance }}</div>
        </v-card>

        <v-card class="pa-3">
          <div class="text-caption">Total Violations</div>
          <div class="text-h5">{{ totalViolations }}</div>
          <div :class="deltaClass(totalDViolations)">
            {{ totalDViolations }} vs Last week
          </div>
        </v-card>

      </v-col>

    </v-row>

      <!--
        Added
          - Mobile breakpoint to 0 to always show all columns (no horizontal scroll)
          - Reduced items per page to 5 for better mobile experience
      -->
 <v-card>
    <v-card-title>

    </v-card-title>

      <v-data-table
        @item-expanded="onRowExpanded"
        item-key="unitId"
        show-expand
        :expanded.sync="expanded"

        :mobile-breakpoint="0"
        :items-per-page="5"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"

        :headers="headers"
        :items="rows"
        :loading="loading"
        class="elevation-1 "
      >

      <!-- Custom expand icon -->
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-btn icon @click.stop="expand(!isExpanded)">
          <v-icon large >
            {{ isExpanded ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
          </v-icon>
        </v-btn>
      </template>

        <!-- Delta coloring -->
<!--         <template v-slot:item.dTrips="{ item }">
          <span :class="deltaClass(item.dTrips)">
            {{ item.dTrips }}
          </span>
        </template>
 -->
        <template v-slot:item.dViolations="{ item }">
          <span :class="deltaClass(item.dViolations)">
            {{ item.dViolations }}
          </span>
        </template>

<!--         <template v-slot:item.dDuration="{ item }">
          <span :class="deltaClassFromString(item.dDuration)">
            {{ item.dDuration }}
          </span>
        </template>
 -->
        <template v-slot:item.dIdle="{ item }">
          <span :class="deltaClassFromString(item.dIdle)">
            {{ item.dIdle }}
          </span>
        </template>

         <template v-slot:item.dSpeedTime="{ item }">
          <span :class="deltaClassFromString(item.dSpeedTime)">
            {{ item.dSpeedTime }}
          </span>
        </template>

<!--         <template v-slot:item.dDistance="{ item }">
          <span :class="deltaClassFromString(item.dDistance)">
            {{ item.dDistance }}
          </span>
        </template>
 -->
        <!-- Highlight TOTAL row -->
        <template v-slot:item.unitId="{ item }">
          <strong v-if="item.unitId === 'TOTAL'">{{ item.unitId }}</strong>
          <span v-else>{{ item.unitId }}</span>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-card flat>

              <!-- Detail Table. added mobile break point -->

                  <div class="sub-table-scroll">
                            <v-progress-linear
                              v-if="item.detailsLoading"
                              indeterminate
                            ></v-progress-linear>

                            <v-data-table
                              v-else
                              :mobile-breakpoint="0"

                              :headers="detailHeaders"
                              :items="item.details"
                              dense

                            >

                          <template v-slot:item.actions="{ item: subItem }">
                                <div style="width: 25px; overflow: hidden;">
                                            <v-btn
                                              icon
                                              small
                                              color="primary"
                                              @click="openDay(subItem, item)"
                                            >
                                              <v-icon small>mdi-open-in-new</v-icon>
                                            </v-btn>

                                </div>

                          </template>

                            <!-- Format the idle column -->
                                <template v-slot:item.Item2[3][1]="{ item }">
                                  {{ formatSeconds(item.Item2[3][1]) }}
                                </template>

                            <!-- Format the distance column -->
                                <template v-slot:item.Item2[1][1]="{ item }">
                                  {{ formatToKm(item.Item2[1][1]) }}
                                </template>

                                <template v-slot:item.Item2[4][1]="{ item }">
                                  {{ formatSeconds(item.Item2[4][1]) }}
                                </template>

                              <template v-slot:item.actions2="{ item: subItem }">
                                    <div style="width: 25px; overflow: hidden;">
                                          <v-btn
                                            icon
                                            small
                                            color="primary"
                                            @click="openNav(subItem, item)" >
                                            <v-icon large>mdi-play-circle</v-icon>
                                          </v-btn>

                                    </div>

                               </template>

                            </v-data-table>
                  </div>

            </v-card>
          </td>
        </template>

      </v-data-table>
  </v-card>

    <!-- ================= KPI CARDS ================= -->

      <v-col cols="12" sm="6" md="3">

      </v-col>

    </v-card>
  </v-container>
</template>

<script>
// import { weekdays } from 'moment';

// import axios from "axios";

export default {
  name: 'Summary',

  data () {
    return {
      // week for which we are showing summary data
      week: 0,
      //
      detailHeaders: [

        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '8px',
          minWidth: '15px',
          class: 'status-col px-0',
          cellClass: 'status-col px-0'
        },

        { text: 'Date', value: 'Item1', width: '40px' },
        { text: 'Violations', value: 'Item2[6][1]', width: '25px', class: 'status-col px-0' },
        { text: 'Idle Time', value: 'Item2[3][1]', width: '20px', class: 'status-col px-0' },
        { text: 'Max Speed', value: 'Item2[5][1]', width: '25px' },
        { text: 'Speed Time', value: 'Item2[4][1]', width: '25px' },
        { text: 'Trips', value: 'Item2[0][1]', width: '25px' },
        { text: 'Distance', value: 'Item2[1][1]', width: '45px' },

        {
          text: '',
          value: 'actions2',
          sortable: false,
          width: '8px',
          minWidth: '15px',
          class: 'status-col px-0',
          cellClass: 'status-col px-0'
        }

        /*         { text: "Date2", value: "Item2" },
        { text: "Start", value: "startTime" },
        { text: "End", value: "endTime" },
        { text: "Distance", value: "distance" } */
      ],
      //
      expanded: [],
      //
      sortBy: 'violations',
      sortDesc: true,
      //
      loading: false,
      rows: [],
      headers: [
        // { text: "Unit", value: "unitId" },
        { text: 'Registration', value: 'RegNumber', width: '50px' }, // fixed: true },

        { text: 'Weeks Violations', value: 'violations', width: '25px' },
        { text: 'Change Violations', value: 'dViolations', width: '15px' },

        { text: 'Weeks Idle Time', value: 'idle', width: '25px' },
        { text: 'Change Idle Time', value: 'dIdle', width: '15px' },

        { text: 'Weeks Speed Time', value: 'speedTime', width: '25px' },
        { text: 'Change Speed Time', value: 'dSpeedTime', width: '15px' },

        { text: 'Weeks Duration Drive Time', value: 'duration', width: '25px' },
        { text: 'Change Duration', value: 'dDuration', width: '15px' },

        { text: 'Weeks Distance (km)', value: 'distance', width: '30px' },
        { text: 'Change Distance (km)', value: 'dDistance', width: '15px' },

        { text: 'Weeks Trip Count', value: 'trips', width: '25px' },
        { text: 'Change Trips', value: 'dTrips', width: '15px' }
      ]
    }
  },

  mounted () {
    this.loadData()
  },

  computed: {
    startOfPreviousWeek () {
      const addDays = this.week * 7

      // Get date from N weeks ago (as YYYY-MM-DD)
      const pastDate = new Date()
      pastDate.setDate(pastDate.getDate() - addDays)

      const year = pastDate.getFullYear()
      const month = String(pastDate.getMonth() + 1).padStart(2, '0')
      const day = String(pastDate.getDate()).padStart(2, '0')

      const input = `${year}-${month}-${day}` // e.g. "2026-04-21"

      // Parse the date
      const date = new Date(input) // YYYY-MM-DD format is safe

      // Calculate days to previous Monday (Monday = start of week)
      const dayOfWeek = date.getDay() // 0=Sunday, 1=Monday, ..., 6=Saturday
      const diff = (7 + (dayOfWeek - 1)) % 7 // 1 = Monday

      const startOfWeek = new Date(date)
      startOfWeek.setDate(startOfWeek.getDate() - diff)

      // Previous week

      const startOfPreviousWeek = new Date(startOfWeek)
      startOfPreviousWeek.setDate(startOfPreviousWeek.getDate() - 7)

      return this.formatDate(startOfPreviousWeek)
    },

    endOfPreviousWeek () {
      const addDays = this.week * 7

      // Get date from N weeks ago (as YYYY-MM-DD)
      const pastDate = new Date()
      pastDate.setDate(pastDate.getDate() - addDays)

      const year = pastDate.getFullYear()
      const month = String(pastDate.getMonth() + 1).padStart(2, '0')
      const day = String(pastDate.getDate()).padStart(2, '0')

      const input = `${year}-${month}-${day}` // e.g. "2026-04-21"

      // Parse the date
      const date = new Date(input) // YYYY-MM-DD format is safe

      // Calculate days to previous Monday (Monday = start of week)
      const dayOfWeek = date.getDay() // 0=Sunday, 1=Monday, ..., 6=Saturday
      const diff = (7 + (dayOfWeek - 1)) % 7 // 1 = Monday

      const startOfWeek = new Date(date)
      startOfWeek.setDate(startOfWeek.getDate() - diff)

      const startOfPreviousWeek = new Date(startOfWeek)
      startOfPreviousWeek.setDate(startOfPreviousWeek.getDate() - 7)

      const endOfPreviousWeek = new Date(startOfWeek)
      endOfPreviousWeek.setDate(endOfPreviousWeek.getDate() - 1)

      // end.setDate(start.getDate() + 6);

      // endOfPreviousWeek.setDate(endOfPreviousWeek.getDate() - 1);
      return this.formatDate(endOfPreviousWeek)
    },

    dataRows () {
      return this.rows.filter(r => r.unitId !== 'TOTAL')
    },

    totalTrips () {
      return this.dataRows.reduce((s, r) => s + r.trips, 0)
    },

    totalDTrips () {
      return this.dataRows.reduce((s, r) => s + r.dTrips, 0)
    },

    totalViolations () {
      return this.dataRows.reduce((s, r) => s + r.violations, 0)
    },

    totalDViolations () {
      return this.dataRows.reduce((s, r) => s + r.dViolations, 0)
    },

    totalDuration () {
      return this.formatSeconds(
        this.dataRows.reduce((s, r) => s + r.durationSeconds, 0)
      )
    },

    totalDistance () {
      return this.formatMeters(
        this.dataRows.reduce((s, r) => s + r.distanceMeters, 0)
      )
    },

    tripsChartData () {
      return {
        labels: this.dataRows.map(r => r.RegNumber),
        datasets: [{ label: 'Trips', data: this.dataRows.map(r => r.trips) }]
      }
    },

    violationsChartData () {
      return {
        labels: this.dataRows.map(r => r.RegNumber),
        datasets: [{ label: 'Violations', data: this.dataRows.map(r => r.violations) }]
      }
    }

  },

  methods: {

    openNav (subItem, item) {
      var log = `/day-trip-navigator/${item.unitId}` +
      `/${item.RegNumber}/summary/` +
      `${this.formatDate_yyyyMMdd(new Date(subItem.Item1))}` +
      `/${0}` // Currently do not have access to Vehicle ID

      console.log('item:', item)

      console.log('subItem:', subItem)

      console.log('Navigating to:', log)
      this.$router.push({ path: log })
    },

    openDay (detailItem, item) {
      var log = `/trip-list-speed/${item.unitId}/${item.RegNumber}/${this.formatDate_yyyyMMdd(new Date(detailItem.Item1))}`

      console.log('item:', item)

      console.log('detailItem:', detailItem)

      console.log('Navigating to:', log)
      this.$router.push({
        path: log

        // item.unitId + '/' + detailItem.RegNumber + '/' + this.formatDate_yyyyMMdd(new Date(detailItem.Item1)) // + '/' + detailItem.Item2[0][1] // unitId/RegNumber/Date/Trips
        //     path: '/trip-list-speed/:UnitID/:VehicleReg/:dayDate', // :unitId/:selectedDate/*',

        // https://localhost:44310/Prod/api/v2/trip/plot-data?UnitID=350317171627023&Day=2026-05-06
        // v2/trip/plot-data?UnitID=350317171627023&Day=2026-05-06

        // OR using named routes:
        // name: "TripView",
        // params: { id: detailItem.tripId }

      })
    },

    incrementWeek () {
      this.week++
      this.loadData()
      // Optional: add your logic here (fetch data, etc.)
    },
    decrementWeek () {
      if (this.week > 0) {
        this.week--
        this.loadData()
      }
      // Optional: prevent going below 0
    },

    formatToKm (meters) {
      if (meters == null) return '-'
      const km = (meters / 1000).toFixed(2) // 2 decimal places
      return `${km} km`
    },

    formatDate (date) {
      const d = new Date(date)

      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

      const dayAbbr = dayNames[d.getDay()]
      const dayOfMonth = String(d.getDate()).padStart(2, '0')
      const monthAbbr = monthNames[d.getMonth()]

      return `${dayAbbr} ${dayOfMonth}, ${monthAbbr}`
    },

    formatDateDddMMdd (d) {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const dayName = days[d.getDay()]

      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${dayName} ${month}-${day}`
    },

    formatDate_yyyyMMdd (d) {
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    async onRowExpanded ({ item, value }) {
      if (value && !item.details) {
        item.detailsLoading = true

        try {
          const url = this.$baseUrl + `/api/v2/summary/by-day?UnitID=${item.unitId}&Week=${this.week}`
          const res = await this.$axios.get(url)

          item.details = res.data
        } catch (e) {
          console.error('Error loading details', e)
          item.details = []
        } finally {
          item.detailsLoading = false
        }
      }
    },

    async loadData () {
      this.loading = true

      try {
        let url = this.$baseUrl
        url += `/api/v2/summary?Week=${this.week}`

        const response = await this.$axios.get(url)

        // Map object[] -> structured object
        this.rows = response.data.map(r => ({
          unitId: r[0],
          RegNumber: r[1] || '',
          trips: r[2],
          dTrips: r[3],
          violations: r[4],
          dViolations: r[5],
          duration: r[6],
          dDuration: r[7],
          distance: r[8],
          dDistance: r[9],
          idle: r[10],
          dIdle: r[11],

          speedTime: r[12],
          dSpeedTime: r[13],

          durationSeconds: r[14],
          distanceMeters: r[15],

          // NEW
          details: null,
          detailsLoading: false

        }))
      } catch (err) {
        console.error('Error loading summary:', err)
      } finally {
        this.loading = false
      }
    },

    formatSeconds (sec) {
      const h = Math.floor(sec / 3600)
      const m = Math.floor((sec % 3600) / 60)
      return `${h}h ${m}m`
    },

    formatMeters (m) {
      return (m / 1000).toFixed(1) + ' km'
    },

    deltaClass (value) {
      if (value < 0) return 'green--text'
      if (value > 0) return 'red--text'
      return ''
    },

    // For formatted strings like "+01:23" or "-5 km"
    deltaClassFromString (val) {
      if (!val) return ''
      if (val.toString().startsWith('+')) return 'red--text'
      if (val.toString().startsWith('-')) return 'green--text'
      return ''
    }
  }
}
</script>

<style scoped>

.elevation-1 thead tr th {
  white-space: normal;
}

.sub-table-scroll {
  overflow-x: auto;   /* enables bottom scrollbar */
  width: 100%;
}

.my-table table {
  table-layout: fixed !important;  /* Enforce fixed layout for consistent column widths */
}

.status-col {
  width: 28px !important;
  max-width: 28px !important;
  min-width: 28px !important;
  padding: 0px 0px 0px 0px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;

}

</style>
